import React, { ReactNode } from 'react';
import { useFieldValue } from 'Shared/utils/hooks';
import { SimpleAvatar as Avatar } from 'Shared/components/Avatar/Avatar';

import EmptyState from './EmptyState/EmptyState';

type PropType = {
  workspaceContent: ReactNode;
  useFirstWorkspaceIfNull?: boolean;
};

export default function Content({ workspaceContent, useFirstWorkspaceIfNull }: PropType) {
  const uuid = useFieldValue('currentWorkspace');
  const workspaces = useFieldValue('workspaces');

  const valueIfNull = useFirstWorkspaceIfNull && workspaces.length ? workspaces[0] : {};
  const { fullName, avatar, isGroup, workspaceName } = workspaces.find(item => item.uuid === uuid) || valueIfNull;

  const workspaceHeader = () => {
    if (!isGroup) {
      return (
        <div className="d-flex w-100">
          <Avatar uuid={uuid} avatar={avatar} />
          <div className="d-flex flex-column pl-2">
            <p className="onboarding-workspaces-preview-content-item-title">{fullName || '1:1 Workspace'}</p>
            <p className="text-muted">Your private 1:1 workspace with {(fullName || '').split(' ')[0]}</p>
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex w-100">
        <Avatar uuid={uuid} avatar={avatar} />
        <div className="d-flex flex-column pl-2">
          <p className="onboarding-workspaces-preview-content-item-title">{workspaceName}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="onboarding-workspaces-preview-content">
      {fullName ? (
        <div className="d-flex flex-column">
          {workspaceHeader()}
          {workspaceContent}
        </div>
      ) : (
        <EmptyState />
      )}
    </div>
  );
}
